import {InitViewTemplateIDs} from '.'
import {IMixerChannel} from './components/channel-collection'
import {defaultLimitChannels, SemanticFilteringItemType} from './components/semantic-filtering'

export * from './hooks'
export * from './components/channel-collection'
export * from './components/channel-collection/channel'
export * from './components/semantic-filtering'
export * from './components/media-list'
export * from './components/media-list-stats'
export * from './components/sidebar'

export interface IFieldDescriptor {
  kind: string
  word?: string
  label: string
  sourcePath: string
  range: {min: number; max: number}
  initView?: InitViewTemplateIDs
  onAdded?: (descriptor: IFieldDescriptor) => void
}

export interface IMixerConfig {
  mediaListViewMode: 'list' | 'portrait' | 'landscape'
  showAdvancedControls: boolean
  keepSelectionInView: boolean
  nestedEpisodes: boolean
}

export interface IMixerState {
  channels: {
    adjust: IMixerChannel[]
    limit: IMixerChannel[]
  }
  selectedItem?: SemanticFilteringItemType
  selectedSeries?: SemanticFilteringItemType
  [key: string]: any
}

export interface IVideoUrl {
  url: string
  ttl: number
}

export interface IMixerUrlParams {
  item: string
  tab: string
  [key: string]: string
}

export const language = 'expression-lang'
export const epsilon = 0.001
export const stepSize = 0.01
export const defaultNavState: IMixerState = {
  channels: {
    adjust: [],
    limit: defaultLimitChannels,
  },
}
